import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { useOptionsLocale } from '../../context/OptionsLanguageContext';

export const OptionsOpenOperationsCard = ({ count }) => {
  const { t } = useOptionsLocale();
  return (
    <Link to="/options/positions" className="block" data-testid="options-open-operations-link-card">
      <Card className="h-full border-white/10 bg-white/[0.03] text-white shadow-none transition-colors hover:border-white/20 hover:bg-white/[0.05]" data-testid="options-open-operations-card">
        <CardHeader className="space-y-3 pb-3">
          <p className="text-xs font-semibold uppercase tracking-[0.24em] text-white/45" data-typography="label" data-testid="options-open-operations-label">{t('dashboard.openOperations')}</p>
          <CardTitle className="text-4xl font-black tracking-tight" data-typography="metric" data-testid="options-open-operations-count">{count}</CardTitle>
        </CardHeader>
        <CardContent className="pt-0">
          <span className="text-sm text-white/60" data-testid="options-open-operations-helper">{t('dashboard.openOperationsHelper')}</span>
        </CardContent>
      </Card>
    </Link>
  );
};

export default OptionsOpenOperationsCard;